import React from "react";
import Logo from "./sam.jpg";
import ContactUs from "./contact/ContactUs"; 

function Topbar() {
    return (
        <div className="Top-header">                    
            <h1 className="intro">Samuel Salgado</h1> 
         <div><img src={Logo} className="logo" alt="pic"/></div>
         <div className="contact"><ContactUs /></div>       

         </div>


    )
}
export default Topbar;